import { Swiper } from 'swiper';
import type { SwiperOptions } from 'swiper/types';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';

const SELECTOR_SLIDER = '[data-slider]';
const SELECTOR_SLIDER_NEXT = '[data-slider-next]';
const SELECTOR_SLIDER_PREV = '[data-slider-prev]';

export class Slider {
  private swiperInstance: Swiper;

  constructor(container: HTMLElement, options: SwiperOptions = {}, customSliderSelector?: string) {
    let sliderElement: Element | null;

    if (customSliderSelector && container.matches(customSliderSelector)) {
      // If the container itself matches the selector, use it directly
      sliderElement = container;
    } else {
      // Otherwise, search for a child element
      sliderElement = container.querySelector(customSliderSelector || SELECTOR_SLIDER);
    }

    if (!sliderElement) {
      throw new Error('Slider element not found');
    }

    const nextButton = container.querySelector(SELECTOR_SLIDER_NEXT) as HTMLElement | null;
    const prevButton = container.querySelector(SELECTOR_SLIDER_PREV) as HTMLElement | null;

    const defaultModules = [Navigation, Pagination, Autoplay, EffectFade];
    const userModules = options.modules || [];

    const uniqueModules = Array.from(new Set([...defaultModules, ...userModules]));

    this.swiperInstance = new Swiper(sliderElement as HTMLElement, {
      slidesPerView: 1,  // Change from 'auto' to 1 for fade effect
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton
      },
      ...options,
      modules: uniqueModules
    });
  }

  destroy() {
    this.swiperInstance.destroy();
  }

  public get instance(): Swiper {
    return this.swiperInstance;
  }
}